import { Image } from '@vinted/web-ui';
import { SOCIAL_FACEBOOK_URL, SOCIAL_INSTAGRAM_URL, SOCIAL_LINKEDIN_URL } from 'constants/routes';
import AppButton from 'components/AppStoreButtons/AppButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FACEBOOK_LOGO = '/assets/icons/social-media/facebook.svg';
const LINKEDIN_LOGO = '/assets/icons/social-media/linkedin.svg';
const INSTAGRAM_LOGO = '/assets/icons/social-media/instagram.svg';

const SocialSection = () => {
  const renderSocialItem = (url, logo) => /*#__PURE__*/_jsx("li", {
    className: "main-footer__social-media-item",
    children: /*#__PURE__*/_jsx("a", {
      className: "main-footer__social-media-link",
      href: url,
      target: "_blank",
      rel: "noopener noreferrer",
      children: /*#__PURE__*/_jsx(Image, {
        src: logo
      })
    })
  });

  return /*#__PURE__*/_jsxs("div", {
    className: "main-footer__social-section",
    children: [/*#__PURE__*/_jsxs("ul", {
      className: "main-footer__social-section-media",
      children: [renderSocialItem(SOCIAL_FACEBOOK_URL, FACEBOOK_LOGO), renderSocialItem(SOCIAL_LINKEDIN_URL, LINKEDIN_LOGO), renderSocialItem(SOCIAL_INSTAGRAM_URL, INSTAGRAM_LOGO)]
    }), /*#__PURE__*/_jsxs("ul", {
      className: "main-footer__social-section-app-store",
      children: [/*#__PURE__*/_jsx("li", {
        className: "main-footer__social-app-store-item",
        children: /*#__PURE__*/_jsx(AppButton, {
          platform: AppButton.Platform.Ios
        })
      }), /*#__PURE__*/_jsx("li", {
        className: "main-footer__social-app-store-item",
        children: /*#__PURE__*/_jsx(AppButton, {
          platform: AppButton.Platform.Android
        })
      })]
    })]
  });
};

export default SocialSection;